<template>
    <div class='login'>
        <div id="login" class="btn-group ic-dropdown ic-dropdown-light">
            <button type="button" id="btn-icon-toggle" :class="'btn btn-secondary dropdown-toggle btn-dropdown-toggle '+checkLogged()" @click="openOption('login-option');" data-toggle="dropdown-menu" aria-haspopup="true" aria-expanded="false">
                <i v-if='!isLoggedIn' class="ri-login-circle-line not-close-onclick" for="btn-icon-toggle"></i>
                <span v-if="isLoggedIn" class='lbl-name-user not-close-onclick' for="btn-icon-toggle"><i class="ri-user-fill"></i> {{ currentUser }}</span>
            </button>
            <div id="login-option" class="dropdown-menu dropdown-list-btn dropdown-max-height">
                <div v-if="!isLoggedIn" @click="login()" class="dropdown-item not-close-onclick">
                    {{ $t("login.login") }}
                </div>
                <div v-if="isLoggedIn" @click="logout()" class="dropdown-item not-close-onclick">
                    {{ $t("login.logout") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    //import axios from 'axios'
    import AuthService from './../auth.js';

    const auth = new AuthService();

    export default {
        name: 'Login',
        data() {
            return {
                zindex: 20,
                currentUser: "",
                isLoggedIn: false,
                accessTokenExpired: true,
                dataEventRecordsItems: [],
            }
        },
        mounted() {
            //verify if user is logged in session
            auth.getUser().then((user) => { 
                if(user != null) {  
                    this.currentUser = user.profile.name;
                    this.accessTokenExpired = user.expired;
                }

                this.isLoggedIn = (user !== null && !user.expired);
            });
        },
        methods: {
            // OIDC METHODS ////
            getusername() {
                return this.currentUser;
            },
            login() {
                auth.login();
            },
            logout() {
                auth.logout();
            },
            /* EXAMPLE TO AUTHORIZE THE PAGE TO CALL API
            getProtectedApiData() {
                const authorizationHeader = 'Authorization';
                auth.getAccessToken().then((userToken) => {
                    axios.defaults.headers.common[authorizationHeader] = `Bearer ${userToken}`;
    
                    axios.get('https://localhost:44355/api/DataEventRecords/')
                    .then((response) => {
                        this.dataEventRecordsItems = response.data;
                    })
                    .catch((error) => {
                        alert(error);
                    });
                });
            },*/
            ////////////////////
            checkLogged() {
                if(this.isLoggedIn) {
                    return 'logged';
                }else{
                    return '';
                }
            },
            openOption (opz) { 
                if($("#"+opz).css("display")=='none'){
                    if(window.outerWidth < 764){
                        $(".dropdown-list-btn").css("display", "none");
                    }

                    this.zindex ++;
                    $("#"+opz).css("display", "block");
                    $("#"+opz).css("z-index", this.zindex);
                }else{
                    $("#"+opz).css("display", "none");
                }
            },
        }
    }
</script>

<style>
    div#login {
        direction: rtl;
    }
    div#login button i {
        margin-right: 40px;
        font-size: 1.5rem;
    }
    div#login button {
        border: 0px !important;
        width: auto !important;
        padding: 0px !important;
        height: auto !important;
        min-height: unset !important;
        margin-right: -20px;
        position: relative;
        margin-left: 20px;
        top: -8px;
    }
    div#login button.logged {
        margin-bottom: 8px;
        top: -3px;
    }
    #login-option {
        position: absolute;
        width: fit-content;
        right: -20px;
    }
    .ic-dropdown {
        width: 100%;
        font-weight: 500;
        color: #748a9d;
    }
    .ic-dropdown.ic-dropdown-light { border-color: #748a9d; }
    .ic-dropdown *,
    .ic-dropdown *:hover { color: #748a9d; }
    .ic-dropdown .btn-secondary:not(:disabled):not(.disabled).active, .ic-dropdown .btn-secondary:not(:disabled):not(.disabled):active, .ic-dropdown.show > .btn-secondary.dropdown-toggle {
        color: #748a9d;
        background-color: inherit;
        border-color: inherit;
    }
    .ic-dropdown .btn-secondary:not(:disabled):not(.disabled).active:focus, .ic-dropdown .btn-secondary:not(:disabled):not(.disabled):active:focus, .ic-dropdown.show > .btn-secondary.dropdown-toggle:focus { box-shadow: none; }
    .ic-dropdown .btn-secondary.focus, .ic-dropdown .btn-secondary:focus { box-shadow: none; }
    .ic-dropdown .dropdown-toggle {
        width: 100%;
        color: #748a9d;
        text-align: left;
        background-color: inherit;
        border-radius: .375rem;
        border-color: inherit;
        margin-top: 1rem;
    }
    .ic-dropdown:not(.show) .dropdown-toggle {
        min-height: 3.75rem;
        margin-top: 0;
    }
    .ic-dropdown .dropdown-toggle::after {
        content: "";
        width: 0.6rem;
        height: .5rem;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13.73' height='8.28' viewBox='0 0 13.73 8.28'%3E%3Cpath d='M.71.71,6.86,6.86,13,.71' fill='none' stroke='%23748a9d' stroke-width='2'/%3E%3C/svg%3E");
        background-size: contain;
        background-repeat: no-repeat;
        transform: rotate(180deg);
        display: inline-block;
        vertical-align: middle;
        border: none;
        position: absolute;
        top: 50%;
        right: 1.5rem;
        margin-top: 1px;
        margin-left: 0;
        transition: all .3s;
    }
    .ic-dropdown:not(.show) .dropdown-toggle::after { transform: rotate(0); }
    .ic-dropdown .dropdown-menu {
        width: 100%;
        color: inherit;
        border-radius: .375rem;
        border-color: inherit;
        padding-top: 1.25rem;
        margin-bottom: -2px;
    }
    .ic-dropdown.show .dropdown-toggle {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
    .ic-dropdown.show .dropdown-menu {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
    .ic-dropdown.ic-dropdown-light .dropdown-item:focus, .ic-dropdown.ic-dropdown-light .dropdown-item:hover, .ic-dropdown.ic-dropdown-light .dropdown-item.active, .ic-dropdown.ic-dropdown-light .dropdown-item:active {
        color: #748a9d;
        text-decoration: none;
        background-color: #f0f4f8;
    }
    .ic-dropdown .dropdown-menu {
        padding-top: 0.5rem;
    }
    span.lbl-name-user {
        text-transform: uppercase;
        font-size: 0.97rem;
        position: relative;
        margin-right: 45px;
        top: 3px;
    }
    span.lbl-name-user i {
        font-size: 0.9rem !important;
        margin-right: 5px !important;
    }
    
    @media screen and (max-width: 600px){
        #login-option {
            right: 0px;
        }
        span.lbl-name-user, .dropdown-item {
            font-size: 0.8rem;
        }
        span.lbl-name-user i {
            font-size: 0.8rem !important;
            position: relative;
            top: 2px;
        }
    }
</style>